import { render, staticRenderFns } from "./bStore_setup_categories.vue?vue&type=template&id=1c9c5b47&scoped=true"
import script from "./bStore_setup_categories.vue?vue&type=script&lang=js"
export * from "./bStore_setup_categories.vue?vue&type=script&lang=js"
import style0 from "./bStore_setup_categories.vue?vue&type=style&index=0&id=1c9c5b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9c5b47",
  null
  
)

export default component.exports